/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Ask_Conversation_Tips_ActionInputs */



/**
* | output |
* | --- |
* | "Ask for conversation tips" |
*
* @param {Nudge_Ask_Conversation_Tips_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_ask_conversation_tips_action = /** @type {((inputs?: Nudge_Ask_Conversation_Tips_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Ask_Conversation_Tips_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vraag gesprekstips")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demander des conseils")
	return /** @type {LocalizedString} */ ("Ask for conversation tips")
});